import { render } from "./App.vue?vue&type=template&id=2e479031&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2e479031&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e479031"],['__file',"src/scripts/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e479031"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e479031', __exports__)) {
    api.reload('2e479031', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=2e479031&scoped=true", () => {
    api.rerender('2e479031', render)
  })

}


export default __exports__